import axios from 'axios'
import StorageConfig from "@/services/config/StorageConfig";
import HttpService from "@/services/base/HttpService";

const ServiceConfig = axios.create({
  timeout: 30000,
  transformResponse: [
    function (data) {
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data)
        } catch (e) {
          /* Ignore */
        }
      }

      return data
    },
  ],
})

// Response Interceptor: Refresh token kalau 401
ServiceConfig.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const refreshToken = StorageConfig.getRefreshToken()
      const oldToken = StorageConfig.getToken()
      if (
          error.response?.status === 401 && oldToken
      ) {
        originalRequest._retry = true;
        try {
          const apiBase = process.env.VUE_APP_VALIANT;

          const res = await axios.post(apiBase+'refresh-token/', {
            refresh: refreshToken,
          });
          const newToken = res.data.access
          StorageConfig.saveToken(newToken)
          // Update header untuk permintaan awal
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return ServiceConfig(originalRequest); // ulangi permintaan
        } catch (refreshError) {
          // refresh gagal → logout
          StorageConfig.clearSession()
          HttpService.removeHeader()
          window.location.href = '/landing';
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    }
);

// logging response request on development environment
if (process.env.NODE_ENV === 'development') {
  ServiceConfig.interceptors.request.use(
    function (config) {
      return config
    },
    function (error) {
      return Promise.reject(error)
    },
  )

  // Add a response interceptor
  ServiceConfig.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      return Promise.reject(error)
    },
  )
}

export default ServiceConfig
